/* Bed Builder — assets/bed-builder.js */
(function () {
  'use strict';

  var COLORS = { 'whisper-pink': 'Whisper Pink', 'goldie': 'Goldie', 'forevergreen': 'Forevergreen' };

  var CDN = 'https://cdn.shopify.com/s/files/1/0592/3569/6736/files/';
  var IMAGES = {
    fitted:      { 'whisper-pink': CDN+'SoonAfter_WhisperPink_Fitted1.png?width=300', 'goldie': CDN+'SoonAfter_GoldieYellow_Fitted1.png?width=300', 'forevergreen': CDN+'SoonAfter_Forevergreen_Fitted1.png?width=300' },
    flat:        { 'whisper-pink': CDN+'SoonAfter_WhisperPink_flat1.png?width=300',   'goldie': CDN+'SoonAfter_GoldieYellow_flat1.png?width=300',   'forevergreen': CDN+'SoonAfter_Forevergreen_flat1.png?width=300' },
    duvet:       { 'whisper-pink': CDN+'SoonAfter_WhisperPink_Duvet1.png?width=300',  'goldie': CDN+'SoonAfter_GoldieYellow_Duvet1.png?width=300',  'forevergreen': CDN+'SoonAfter_Forevergreen_Duvet1.png?width=300' },
    pillowcases: { 'whisper-pink': CDN+'SoonAfter_WhisperPink_Pillow2.png?width=300', 'goldie': CDN+'SoonAfter_GoldieYellow_Pillow2.png?width=300', 'forevergreen': CDN+'SoonAfter_Forevergreen_Pillow1.png?width=300' },
    extra:       { 'whisper-pink': CDN+'SoonAfter_WhisperPink_Pillow1.png?width=300', 'goldie': CDN+'SoonAfter_GoldieYellow_Pillow1.png?width=300', 'forevergreen': CDN+'SoonAfter_Forevergreen_Pillow1.png?width=300' }
  };

  /* Variant IDs from live Shopify catalog */
  var VARIANTS = {
    fitted: {
      'whisper-pink':  { Double: 42340923244640, Queen: 42340923277408, King: 42340923310176 },
      'goldie':        { Double: 42340917510240, Queen: 42340917543008, King: 42340917575776 },
      'forevergreen':  { Double: 42340916232288, Queen: 42340916265056, King: 42340916297824 }
    },
    flat: {
      'whisper-pink':  { Double: 42340926226528, Queen: 42340926259296, King: 42340926292064 },
      'goldie':        { Double: 42340930814048, Queen: 42340930846816, King: 42340930879584 },
      'forevergreen':  { Double: 42340932255840, Queen: 42340932288608, King: 42340932321376 }
    },
    duvet: {
      'whisper-pink':  { Double: 42337828143200, Queen: 42337828175968, King: 42337828208736 },
      'goldie':        { Double: 42337821982816, Queen: 42337822015584, King: 42337822048352 },
      'forevergreen':  { Double: 42337771028576, Queen: 42337771061344, King: 42337771094112 }
    },
    pillowcases: { 'whisper-pink': 42340938842208, 'goldie': 42340934516832, 'forevergreen': 42340940709984 },
    extra:       { 'whisper-pink': 42340938842208, 'goldie': 42340934516832, 'forevergreen': 42340940709984 }
  };

  var PRICES  = { fitted: { Double:130, Queen:150, King:170 }, flat: { Double:120, Queen:140, King:160 }, duvet: { Double:210, Queen:230, King:250 }, pillowcases:75, extra:75 };
  var LABELS  = { fitted:'Fitted Sheet', flat:'Flat Sheet', duvet:'Duvet Cover', pillowcases:'2 × Pillowcases', extra:'Extra 2 × Pillowcases' };

  var SIZE_ITEMS     = ['fitted','flat','duvet'];
  var REQUIRED_ITEMS = ['fitted','duvet','pillowcases'];
  var OPTIONAL_ITEMS = ['flat','extra'];
  var ALL_ITEMS      = ['fitted','flat','duvet','pillowcases','extra'];

  var state = {
    size: null,
    fitted: { color:null }, flat: { color:null, on:false },
    duvet:  { color:null }, pillowcases: { color:null }, extra: { color:null, on:false }
  };

  /* ── helpers ─────────────────────────────────────── */
  function fmt(n){ return '$'+n.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g,','); }

  function getPrice(item){
    return SIZE_ITEMS.indexOf(item)>=0 ? (state.size ? PRICES[item][state.size] : null) : PRICES[item];
  }

  function getVariantId(item){
    var color = state[item].color;
    if(!color) return null;
    return SIZE_ITEMS.indexOf(item)>=0 ? (state.size ? VARIANTS[item][color][state.size] : null) : VARIANTS[item][color];
  }

  function isOn(item){ return OPTIONAL_ITEMS.indexOf(item)>=0 ? state[item].on : true; }

  function canAdd(){
    if(!state.size) return false;
    return REQUIRED_ITEMS.every(function(item){ return state[item].color !== null; });
  }

  /* ── DOM helpers ─────────────────────────────────── */
  function updateImage(item, color){
    var img = document.getElementById(item+'-img');
    var ph  = document.getElementById(item+'-placeholder');
    if(!img) return;
    if(color && IMAGES[item] && IMAGES[item][color]){
      img.src = IMAGES[item][color];
      img.classList.add('visible');
      if(ph) ph.style.display='none';
    } else {
      img.classList.remove('visible');
      if(ph) ph.style.display='flex';
    }
  }

  function updateLabel(item, color){
    var el = document.getElementById(item+'-selected');
    if(!el) return;
    if(color){
      var parts=[COLORS[color]];
      if(SIZE_ITEMS.indexOf(item)>=0 && state.size) parts.push(state.size);
      el.textContent = parts.join(' / ');
    } else { el.textContent=''; }
  }

  function updatePriceEl(item){
    var el = document.getElementById(item+'-price');
    if(!el) return;
    var price = getPrice(item);
    if(price){ el.textContent = fmt(price); }
    else {
      var vals = Object.keys(PRICES[item]).map(function(k){ return PRICES[item][k]; });
      el.textContent = 'From '+fmt(Math.min.apply(null,vals));
    }
  }

  function setSwatchActive(item, activeColor){
    document.querySelectorAll('.bb-swatch[data-item="'+item+'"]').forEach(function(s){
      s.classList.toggle('active', s.dataset.color===activeColor);
    });
  }

  /* ── summary ─────────────────────────────────────── */
  function renderSummary(){
    var container  = document.getElementById('bb-summary-items');
    var totalRow   = document.getElementById('bb-total-row');
    var totalPrice = document.getElementById('bb-total-price');
    var addBtn     = document.getElementById('bb-add-btn');
    var rows='', total=0, count=0;

    ALL_ITEMS.forEach(function(item){
      if(!isOn(item)) return;
      var color = state[item].color;
      if(!color) return;
      var price = getPrice(item);
      if(!price) return;
      count++; total+=price;
      var detail = COLORS[color];
      if(SIZE_ITEMS.indexOf(item)>=0 && state.size) detail += ' — '+state.size;
      rows += '<div class="bb-summary__item"><div><div class="bb-summary__item-name">'+LABELS[item]+'</div>'
            + '<div class="bb-summary__item-detail">'+detail+'</div></div>'
            + '<div class="bb-summary__item-price">'+fmt(price)+'</div></div>';
    });

    if(count>0){
      container.innerHTML=rows;
      totalRow.style.display='flex';
      totalPrice.textContent=fmt(total);
    } else {
      container.innerHTML='<div class="bb-summary__empty">Select your pieces above and watch your bed come together.</div>';
      totalRow.style.display='none';
    }
    addBtn.disabled = !canAdd();
  }

  /* ── events ──────────────────────────────────────── */
  document.querySelectorAll('.bb-size-btn').forEach(function(btn){
    btn.addEventListener('click',function(){
      state.size = btn.dataset.size;
      document.querySelectorAll('.bb-size-btn').forEach(function(b){ b.classList.toggle('active',b===btn); });
      SIZE_ITEMS.forEach(function(item){ updatePriceEl(item); updateLabel(item,state[item].color); });
      renderSummary();
    });
  });

  document.querySelectorAll('.bb-swatch').forEach(function(sw){
    sw.addEventListener('click',function(){
      var item=sw.dataset.item, color=sw.dataset.color;
      state[item].color=color;
      setSwatchActive(item,color);
      updateImage(item,color);
      updateLabel(item,color);
      if(SIZE_ITEMS.indexOf(item)>=0) updatePriceEl(item);
      renderSummary();
    });
  });

  ['flat','extra'].forEach(function(item){
    var toggle  = document.getElementById(item+'-toggle');
    var content = document.getElementById(item+'-content');
    if(!toggle) return;
    toggle.addEventListener('click',function(){
      state[item].on = !state[item].on;
      toggle.classList.toggle('active',state[item].on);
      toggle.setAttribute('aria-pressed',state[item].on);
      content.classList.toggle('open',state[item].on);
      if(!state[item].on){
        state[item].color=null;
        setSwatchActive(item,null);
        updateImage(item,null);
        updateLabel(item,null);
      }
      renderSummary();
    });
  });

  var addBtn     = document.getElementById('bb-add-btn');
  var validation = document.getElementById('bb-validation');

  function showMsg(msg){ validation.textContent=msg; clearTimeout(validation._t); validation._t=setTimeout(function(){ validation.textContent=''; },4000); }

  addBtn.addEventListener('click',function(){
    if(!canAdd()){
      showMsg(!state.size ? 'Please choose a bed size first.' : 'Please choose a colour for your fitted sheet, duvet cover, and pillowcases.');
      return;
    }
    var items=[];
    ALL_ITEMS.forEach(function(item){
      if(!isOn(item)) return;
      var id=getVariantId(item);
      if(id) items.push({ id:id, quantity:1 });
    });
    if(!items.length) return;

    addBtn.disabled=true; addBtn.classList.add('is-loading'); addBtn.textContent='Adding…';

    fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({items:items})
    })
    .then(function(res){ if(!res.ok) throw new Error(''+res.status); return res.json(); })
    .then(function(){
      var selectors=['[data-open-drawer="cart-drawer"]','[data-cart-drawer-trigger]','[data-drawer-open="cart"]','.js-cart-count-bubble'];
      var triggered=false;
      for(var i=0;i<selectors.length;i++){
        var el=document.querySelector(selectors[i]);
        if(el){ el.click(); triggered=true; break; }
      }
      document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
      if(!triggered) window.location.href='/cart';
    })
    .catch(function(err){ console.error('[Bed Builder]',err); showMsg('Something went wrong. Please try again.'); })
    .finally(function(){ addBtn.disabled=false; addBtn.classList.remove('is-loading'); addBtn.textContent='Add to Cart'; });
  });

  renderSummary();
})();
